import { genKey } from '../../utils/addKey';

const addKeyToColumns = (tRow) => {
    const row = { ...tRow };
    row.columns = row.columns.map((c) => ({
        ...c,
        key: `co-${genKey()}`
    }));
    return row;
};

const addKeyToRows = (tSection) => {
    const section = { ...tSection };
    section.layout.rows = section.layout.rows.map((r) => ({
        ...addKeyToColumns(r),
        key: `r-${genKey()}`
    }));
    return section;
};

export const addKeysToVDEData = (tData) => {
    const data = { ...tData };
    data.sections = data.sections.map((s) => ({
        ...addKeyToRows(s),
        key: s.title
    }));
    return data;
};
